import { isPendingPix } from '@src/domains/transactions/core/isPendingPix';
import type { Transaction } from '@src/domains/transactions/types/transaction';

export const resolvePixExpiration = (transaction: Transaction | null | undefined): Date | null =>
  isPendingPix(transaction) ? new Date(transaction!.expiresAt!) : null;
